export const commentsLengthError = (comments, maximumLength) =>
    Number.isFinite(maximumLength) && comments?.length > maximumLength
        ? `Additional Comments cannot exceed ${maximumLength} characters.`
        : null;
